import { chain, get, orderBy } from 'lodash';
import { createSelector } from 'reselect';

import {
    DMARC_POLICY_INHERITED_NONE,
} from '../../common/constants/dmarc-policy-values';
import {
    actionsByDomainSelector,
    actionsIsLoadingSelector
} from '../../common/selectors/actions-selectors';
import {
    aggResultsIsLoadingSelector,
    flatAggregateResultsByDomainSelector
} from '../../common/selectors/aggregate-results-selectors';
import { calculateRate } from '../../utils/common-utils';
import {
    domainsByIdSelector,
    domainsIsLoadingSelector
} from '../../common/selectors/domains-selectors';
import { translate } from '../../utils/translation-utils';

const mapDomainData = ( row, domainDetails = {}, actions = [] ) => {
    const authorizedMailVolume = row.authorizedMailVolume;
    const domainType = get( domainDetails, 'domainType', null );
    const dmarcPolicy = get( domainDetails, 'dmarc.policy', null ) === null ? 'no_record' : domainDetails.dmarc.policy;

    return {
        actionsCount: actions.length,
        authorizedMailVolume,
        dkimAlignCount: row.dkimAlignCount,
        dkimAlignRate: calculateRate( authorizedMailVolume, row.dkimAlignCount ),
        dkimPassAlignCount: row.dkimPassAlignCount,
        dkimPassAlignRate: calculateRate( authorizedMailVolume, row.dkimPassAlignCount ),
        dkimPassCount: row.dkimPassCount,
        dkimPassRate: calculateRate( authorizedMailVolume, row.dkimPassCount ),
        dmarcDoublePassCount: row.dmarcDoublePassCount,
        dmarcDoublePassRate: calculateRate( authorizedMailVolume, row.dmarcDoublePassCount ),
        dmarcPassCount: row.dmarcPassCount,
        dmarcPassRate: calculateRate( authorizedMailVolume, row.dmarcPassCount ),
        dmarcPolicy,
        dmarcPolicyInherited: get( domainDetails, 'dmarc.policyInherited', DMARC_POLICY_INHERITED_NONE ),
        dmarcStatus: get( domainDetails, 'dmarc.status', null ),
        domainCount: 1,
        domainName: row.domainName,
        domainType: translate( domainType ),
        orgDomain: domainDetails.orgDomain,
        percentBlocked: calculateRate( authorizedMailVolume, row.blockedMailCount ),
        percentBlockedCount: row.blockedMailCount,
        spfAlignCount: row.spfAlignCount,
        spfAlignRate: calculateRate( authorizedMailVolume, row.spfAlignCount ),
        spfPassAlignCount: row.spfPassAlignCount,
        spfPassAlignRate: calculateRate( authorizedMailVolume, row.spfPassAlignCount ),
        spfPassCount: row.spfPassCount,
        spfPassRate: calculateRate( authorizedMailVolume, row.spfPassCount ),
        unauthorizedMailVolume: row.unauthorizedMailVolume,
    };
};

export const myDomainsDataIsLoadingSelector = createSelector(
    aggResultsIsLoadingSelector,
    domainsIsLoadingSelector,
    actionsIsLoadingSelector,
    ( aggResultsIsLoading, domainsIsLoading, actionsIsLoading ) => {
        return aggResultsIsLoading || domainsIsLoading || actionsIsLoading;
    }
);

export const myDomainsTableDataSelector = createSelector(
    flatAggregateResultsByDomainSelector,
    domainsByIdSelector,
    actionsByDomainSelector,
    ( aggDataByDomain, domainMap, actionsByDomain ) => {
        const result = chain( aggDataByDomain )
            .filter( aggRow => domainMap[aggRow.domainName] )   // filter out domains from aggRow that don't exist in domain map
            .map( aggRow => mapDomainData( aggRow, domainMap[aggRow.domainName], actionsByDomain[aggRow.domainName] ) )
            .value();

        return orderBy( result, ['orgDomain', 'domainName'], ['asc', 'asc'] );
    }
);
